//import './foundation.js'
import '../sass/app.scss'

import Vue from 'vue'

import lax from 'lax.js'

import SmoothScroll from 'smooth-scroll'

let scrollDown = new SmoothScroll()

let menu = document.querySelector('[data-menu]')
if(menu) {
  menu.addEventListener('click',e => {
    e.preventDefault();
    document.body.classList.toggle('menu-open')
  })
}

new Vue({
    el: '#portfolio',
    data() {
        return {
            active: '01',
            categories: [
                {
                    title: 'UX &amp; Web Design',
                    order: '01',
                    image: '/assets/images/vt-homepage.jpg',
                    link: '/ux-web-design.html'
                },
                {
                    title: 'Logos &amp; Branding',
                    order: '02',
                    image: '/assets/images/wandering-wilsons-homepage.jpg',
                    link: '/branding.html'
                },
                {
                    title: 'Art Direction',
                    order: '03',
                    image: '/assets/images/mbs-homepage.jpg',
                    link: '/art-direction.html'
                    
                },
                {
                    title: 'Illustration',
                    order: '04',
                    image: '/assets/images/owl-homepage.jpg',
                    link: '/illustration.html'
                },
            ]
        }
    },
    mounted() {
        let scrollButton = document.querySelector('.scroll-down')
        scrollButton.addEventListener('click', e => {
            e.preventDefault()
            scrollDown.animateScroll(this.$el)
        })
    }
})

window.onload = function() {
	lax.setup() // init
	  
	document.addEventListener('scroll', function(e) {
	  lax.update(window.scrollY) // update every scroll
	}, false)
}


// WEBPACK FOOTER //
// ./assets/js/app.js